import React, {Component} from 'react'
import AmCharts from "@amcharts/amcharts3-react";

function generateColor(){
    var colors = ['red', 'green', 'blue', 'orange', 'yellow'];
    var new_c = [];
    var aa = colors[Math.floor(Math.random() * colors.length)];
    new_c.push(aa);
    return new_c;
}
// Generate random data
// function generateData() {
//     var firstDate = new Date();
//
//     var dataProvider = [];
//
//     for (var i = 0; i < 100; ++i) {
//         var date = new Date(firstDate.getTime());
//
//         date.setDate(i);
//
//         dataProvider.push({
//             date: date,
//             value: Math.floor(Math.random() * 100)
//         });
//     }
//
//     return dataProvider;
// }

class BarChart extends Component {

    constructor(props) {
        super(props);
        // this.state = {
        //     dataProvider: generateData(),
        //     timer: null
        // };
    }

    componentDidMount() {
        // this.setState({
        //     // Update the chart dataProvider every 3 seconds
        //     timer: setInterval(() => {
        //         this.setState({
        //             dataProvider: generateData()
        //         });
        //     }, 40000)
        // });
        // console.log(this.state.dataProvider);

    }
    componentWillUnmount() {
        // clearInterval(this.state.timer);
    }

    render() {
        var categoryCount = (this.props.data || []).length;
        var graphs = [];
        var l = 1;
        var fileName = ''
        if(this.props.name===null || this.props.name==='null' || this.props.name===undefined || this.props.name==='undefined') {
          fileName = "chartData"
        }
        fileName = this.props.name;

        var barColors = ["#2196f3","#3366cc","#dc3912","#ff9900","#109618","#990099","#0099c6","#dd4477","#66aa00","#b82e2e","#316395","#3366cc","#994499","#22aa99","#aaaa11","#6633cc","#e67300","#8b0707","#651067","#329262","#5574a6","#3b3eac","#b77322","#16d620","#b91383","#f4359e","#9c5935","#a9c413","#2a778d","#668d1c","#bea413","#0c5922","#743411"]
        this.props.y_axis.map(function (pl, index) {
            graphs.push({
                "balloonText": "[[category]]<br>"+pl+":[[value]]",
                "fillAlphas": 0.8,
                "id": "AmGraph-"+l,
                "lineAlpha": 0.2,
                "title": pl,
                "type": "column",
                "valueField": pl,
                "fillColors":barColors[index],
            });
            l++;
        })
        const config = {
            "type": "serial",
            // Relative width so columns shrink to fit the card instead of overlapping
            "columnWidth": 0.7,
            "theme": "none",
            "legend": {
                "autoMargins": false,
                "position": "bottom",
                "borderAlpha": 0,
                "equalWidths": false,
                "horizontalGap": 10,
                "markerSize": 10,
                "useGraphSettings": true,
                "valueAlign": "left",
                "valueWidth": 0,
                "fontSize":8,
            },
            "categoryField": this.props.x_axis,
            "rotate": false,
            "startDuration": 1,
            "marginTop": 5,
            //"marginBottom": 55,
            "categoryAxis": {
                "gridPosition": "start",
                // Label every category (e.g. every date) instead of amCharts' auto-skipped subset
                "autoGridCount": false,
                "gridCount": categoryCount,
                "position": "left",
                "labelRotation": categoryCount > 12 ? 90 : 25,
                "fontSize":9
            },
            "trendLines": [],
            "graphs": graphs,
            "guides": [],
            "valueAxes": [
                {
                    "id": "ValueAxis-1",
                    "position": "left",
                    "axisAlpha": 0
                }
            ],
            "allLabels": [],
            "balloon": {},
            "titles": [],
            "dataProvider": this.props.data,
            // "chartCursor": {
            //     "categoryBalloonEnabled": false,
            //     "cursorAlpha": 0,
            //     "zoomable": true
            // },
            "export": {
              "enabled": true,
                "fileName": fileName.replace(/ /g,"_"),
                "menu": [ {
                "class": "export-main",
                "menu": ["XLSX", "CSV" ],
              } ]
            }
    };

        return (
            <div className ="chart_div" >
                <AmCharts.React style={{ width: "100%", height: this.props.chartHeight }} options={config} />
            </div>
        );
    }
      }

export default BarChart;